/** auth */
const authUserInfo = state => state.auth.userInfo
const needPrerequisite = state => state.auth.needPrerequisite
const authPrerequisites = state => state.auth.prerequisites
const authPrerequisiteFlag = state => state.auth.prerequisites.length > 0
const authServiceGroups = state => state.auth.serviceGroups
const requiredService = state => state.auth.requiredService
const authMessage = state => state.auth.message

/** auth/resource */
const authResource = state => state.auth.resource
const groups = state => state.auth.resource.groups
const groupProjectMap = state => state.auth.resource.groupProjectMap
const projectTypeMap = state => state.auth.resource.projectTypeMap
const accountGroups = state => state.auth.resource.groups
const projectIdxs = state => state.auth.resource.projectIdxs
const projects = state => state.auth.resource.projects
const myOwnProjects = state => state.auth.resource.myOwnProjects
const additionalProjects = state => state.auth.resource.additionalProjects
const accountMap = state => state.auth.resource.accountMap
const userRights = state => state.auth.resource.userRights

/** common */
const internalUser = state => state.auth.userInfo.internalUser
const changeProject = state => state.changeProject
const months = state => state.months
const selectedGroup = state => state.selectedGroup
const selectedProject = state => state.selectedProject
const selectedMonth = state => state.selectedMonth || state.months[0]
const selectedMonthRange = state => state.selectedMonthRange || state.months
const qtype = state => {
    const isInternalUser = !!state.auth.userInfo.internalUser
    if (!isInternalUser && state.changeProject.event === 'all') {
        return 'all'
    } else if (state.changeProject.event === 'group') {
        return 'group'
    } else if (state.changeProject.event === 'project') {
        return 'project'
    } else {
        return null
    }
}

const initialProject = state => {
    if (state.selectedProject?.projectIdx) {
        return state.selectedProject
    } else if (state.auth.resource.myOwnProjects.length) {
        return state.auth.resource.myOwnProjects[0]
    } else if (state.auth.resource.projects.length) {
        return state.auth.resource.projects[0]
    } else if (state.auth.resource.additionalProjects.length) {
        return state.auth.resource.additionalProjects[0]
    } else {
        return initialProject.value
    }
}

/** board */
const boardDocuments = state => state.boardDocuments
const boardDocument = state => state.boardDocument
const boardDocumentsStatus = state => state.boardDocumentsStatus

/** agreement when first `Megazone Pops` login */
const privacyDocument = state => state.privacy.document
const privacyDocumentVersions = state => state.privacy.versions

/** region */
const regions = state => state.regions

/** Tags */
const tags = state => state.tags
export default {
    /** auth */
    authUserInfo,
    needPrerequisite,
    authPrerequisites,
    authPrerequisiteFlag,
    authServiceGroups,
    requiredService,
    authMessage,

    /** auth/resource */
    authResource,
    groups,
    groupProjectMap,
    projectTypeMap,
    accountGroups,
    projectIdxs,
    projects,
    myOwnProjects,
    additionalProjects,
    accountMap,
    userRights,

    /** common */
    internalUser,
    changeProject,
    months,
    selectedGroup,
    selectedProject,
    selectedMonth,
    selectedMonthRange,
    qtype,
    initialProject,

    /** board */
    boardDocuments,
    boardDocument,
    boardDocumentsStatus,

    /** agreement when first `Megazone Pops` login */
    privacyDocument,
    privacyDocumentVersions,

    /** region */
    regions,

    /** Tags */
    tags
}
